var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,null,{ handleClickUploadBtn: _vm.handleClickUploadBtn, loading: _vm.loading, maxFileSize: _vm.maxFileSize, fileType: _vm.fileType }),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"visibility":"hidden","height":"0","width":"0"},attrs:{"type":"file","accept":"audio/*"},on:{"change":_vm.handleFileUpload}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c073850","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/flow/UploadAudio.vue
// module id = null
// module chunks = 